export default function WhyTrainingsFail() {
  const failures = [
    { icon: 'ri-close-circle-line', title: 'Нет диагностики', desc: 'Тренинг проводится «для галочки», без понимания текущего уровня Soft Skills и реальных проблем компании. Результат: обучение не решает бизнес-задачи.' },
    { icon: 'ri-close-circle-line', title: 'Нет практики', desc: '80% времени — лекции и презентации, только 20% — практика. Сотрудники слушают, но не пробуют. Без практики навык не формируется.' },
    { icon: 'ri-close-circle-line', title: 'Нет внедрения', desc: 'После тренинга сотрудники возвращаются в привычную среду, где никто не требует применять новые навыки. Через 2 недели всё забывается.' },
    { icon: 'ri-close-circle-line', title: 'Нет сопровождения', desc: 'Один тренинг — и «свободны». Без поддержки, коучинга и обратной связи 87% полученных знаний теряются в течение первого месяца.' },
    { icon: 'ri-close-circle-line', title: 'Нет измерения результатов', desc: 'Невозможно понять, окупилось ли обучение. Без KPI и замеров «до и после» инвестиции в обучение становятся необоснованными.' },
    { icon: 'ri-close-circle-line', title: 'Нет поддержки руководителей', desc: 'Руководители не включены в процесс, не требуют применения новых навыков и не подают пример. Развитие Soft Skills становится личным делом сотрудника.' },
  ];

  const systemSteps = [
    { icon: 'ri-search-eye-line', title: 'Диагностика', desc: 'Понимаем, где компания сейчас и куда хочет прийти' },
    { icon: 'ri-tools-fill', title: 'Практика', desc: '80% тренинга — отработка навыков на реальных ситуациях' },
    { icon: 'ri-rocket-2-line', title: 'Внедрение', desc: 'Превращаем инструменты в ежедневные привычки' },
    { icon: 'ri-heart-pulse-line', title: 'Сопровождение', desc: 'Поддерживаем изменения в течение 2-3 месяцев' },
  ];

  return (
    <section className="py-20 md:py-28 bg-white">
      <div className="max-w-7xl mx-auto px-6">
        <h2 className="text-3xl md:text-5xl font-bold text-gray-900 text-center mb-6">
          Почему обычные тренинги по Soft Skills не работают
        </h2>
        <p className="text-lg text-gray-600 text-center mb-16 max-w-3xl mx-auto">
          Большинство компаний разочаровываются в обучении, потому что сталкиваются с одними и теми же проблемами. Вот что идёт не так — и как мы это исправляем.
        </p>

        <div className="grid sm:grid-cols-2 lg:grid-cols-3 gap-5 mb-16">
          {failures.map((item, i) => (
            <div key={i} className="bg-red-50 border border-red-200 rounded-xl p-6">
              <div className="w-10 h-10 bg-red-600 rounded-lg flex items-center justify-center mb-4">
                <i className={`${item.icon} text-lg text-white`}></i>
              </div>
              <h3 className="font-bold text-gray-900 mb-2 text-sm">{item.title}</h3>
              <p className="text-gray-600 text-xs leading-relaxed">{item.desc}</p>
            </div>
          ))}
        </div>

        <div className="max-w-4xl mx-auto">
          <div className="text-center mb-12">
            <h3 className="text-2xl md:text-3xl font-bold text-gray-900 mb-4">
              Методология BusinessTraining.by
            </h3>
            <p className="text-lg text-gray-600">Система из четырёх этапов, которая гарантирует результат</p>
          </div>

          <div className="relative">
            <div className="hidden md:block absolute top-14 left-[12%] right-[12%] h-1 bg-teal-200 rounded-full"></div>
            <div className="grid grid-cols-2 md:grid-cols-4 gap-4 md:gap-0">
              {systemSteps.map((step, i) => (
                <div key={i} className="relative text-center">
                  <div className="w-14 h-14 bg-teal-600 rounded-full flex items-center justify-center mx-auto mb-4 relative z-10 ring-4 ring-white">
                    <i className={`${step.icon} text-xl text-white`}></i>
                  </div>
                  <h4 className="font-bold text-gray-900 mb-2 text-sm">{step.title}</h4>
                  <p className="text-gray-600 text-xs leading-relaxed px-2">{step.desc}</p>
                  {i < 3 && <div className="hidden md:block absolute top-7 left-[60%] text-teal-400 text-2xl font-bold">→</div>}
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}